import React, { useState, useEffect } from "react";
import { IconButton, Menu, MenuItem, Divider } from "@mui/material";
import { 
  AccountCircle, 
  Person, 
  Settings, 
  SupervisorAccount // Icon for Manage Users
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { Routes as AppRoutes } from "../../Routes"; // Renamed to avoid confusion if needed, or keep as is
import APIService from "../../Api/ApiService";

interface DashboardHeaderProps {
  lastUpdated: Date;
  onLogout: () => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  lastUpdated,
  onLogout,
}) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  
  // State to track admin privileges
  const [isAdmin, setIsAdmin] = useState(false);
  const [userName, setUserName] = useState("");

  // Check user role on component mount
  useEffect(() => {
    const checkUserRole = async () => {
      try {
        const profile = await APIService.GetMyProfile();
        setUserName(profile.email);
        if (profile && profile.role === 'admin') {
          setIsAdmin(true);
        }
      } catch (err) {
        console.error("DashboardHeader: Failed to fetch profile for role check", err);
      }
    };

    checkUserRole();
  }, []);

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleOptionsClick = () => {
    handleMenuClose();
    navigate(AppRoutes.OPTIONS_PAGE); 
  };

  const handleManageUsersClick = () => {
    handleMenuClose();
    navigate(AppRoutes.ADMIN_PAGE);
  };

  const handleLogoutClick = () => {
    handleMenuClose();
    onLogout();
  };

  return (
    <div className="custom-app-bar">
      <div className="header-left">
        <img src="csi_stemma_white.svg" alt="Logo" />
      </div>
      <div className="header-center">
        <h1>SyMon Monitor Status</h1>
        <span>
          {lastUpdated.toLocaleDateString()} {lastUpdated.toLocaleTimeString()}
        </span>
      </div>
      <div className="header-right">
        <IconButton size="small" color="inherit" onClick={handleMenuClick}>
          <AccountCircle />
        </IconButton>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          {/* User ID Display */}
          <MenuItem disabled>
            <Person sx={{ mr: 1 }} />
            {userName}
          </MenuItem>

          <Divider />

          {/* Manage Users - Only for Admins */}
          {isAdmin && (
            <MenuItem onClick={handleManageUsersClick}>
              <SupervisorAccount sx={{ mr: 1, fontSize: 20 }} />
              Gestione Utenti
            </MenuItem>
          )}

          {/* Options */}
          <MenuItem onClick={handleOptionsClick}>
            <Settings sx={{ mr: 1, fontSize: 20 }} />
            Opzioni
          </MenuItem>

          <Divider />

          {/* Logout */}
          <MenuItem onClick={handleLogoutClick}>Logout</MenuItem>
        </Menu>
      </div>
    </div>
  );
};

export default DashboardHeader;